import { Close } from '@mui/icons-material';
import { Box, IconButton, Modal, SxProps, Typography, useMediaQuery, useTheme } from '@mui/material'
import { t } from 'i18next';
import React, { ReactNode } from 'react'
import { JsxElement } from 'typescript'


type BaseModalProps = {
    open: boolean,
    handleClose: () => void,
    children: ReactNode,
    title?: string,
    width?: number | string,
    styleProps?: Record<string,any>
}


function BaseModal({ open, handleClose, children, title, width = 400, styleProps }: BaseModalProps) {
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm")); // sm: 600px



    const style = {
        position: 'absolute' as 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: isSmallScreen ? '80%' : width,
        maxHeight: '80%',
        overflowY: 'auto',
        border: '1px solid rgba(239, 239, 240,0.1)',
        p: 3,
        borderRadius: 1,
        background: "rgba(30, 30, 40, 0.9)", /* Balanced darkness */
        backdropFilter: "blur(2px) !important", // Strong blur for iOS glass effect
        "-webkit-backdrop-filter": "blur(2px) !important", // Safari support
        ...(styleProps ? styleProps : {})
    }

    return (
        <Modal
            keepMounted={false}
            open={open}
            onClose={(event, reason) => {
                handleClose()
            }}
        >
            <Box sx={style}>
                <Box display={'flex'} justifyContent={'space-between'} alignItems={'center'} mb={2}>
                    <Typography variant='h6'>
                        {title && t(title)}
                    </Typography>
                    <IconButton size='small' onClick={handleClose}>
                        <Close></Close>
                    </IconButton>
                </Box>
                {children}
            </Box>
        </Modal >
    )
}

export default BaseModal